// extracted by mini-css-extract-plugin
export default {"wrapper":"JournalPageWrapper_wrapper__iWVSM","root":"JournalPageWrapper_root__EQzt4","root_more":"JournalPageWrapper_root_more__qSgtr"};